import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

/** Clip-path wipe reveal on scroll with a subtle inner parallax. */
export default function ImageReveal({
  src,
  alt = "",
  className = "",
  imgClassName = "",
  direction = "up",
  parallax = 12,
  delay = 0,
  ...rest
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${parallax}%`, `${parallax}%`]);

  const from = {
    up: "inset(100% 0 0 0)",
    down: "inset(0 0 100% 0)",
    left: "inset(0 100% 0 0)",
    right: "inset(0 0 0 100%)",
  }[direction];

  return (
    <motion.div
      ref={ref}
      className={`overflow-hidden ${className}`}
      initial={{ clipPath: from }}
      whileInView={{ clipPath: "inset(0 0 0 0)" }}
      viewport={{ once: true, margin: "-15% 0px" }}
      transition={{ duration: 1.2, ease: EASE, delay }}
      {...rest}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y, scale: 1 + parallax / 40 }}
        className={`img-editorial h-full w-full object-cover ${imgClassName}`}
      />
    </motion.div>
  );
}
